import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './FinalMonthlyReport.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { format } from 'date-fns';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getProjects, getStates, getClients, getProject, fetchMonths, getFinalAttendanceReport } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
const FinalMonthlyReport = () => {
    const currentYear = new Date().getFullYear();
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(0);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(currentYear);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    const [clientResponse, setClientResponse] = useState([]);
    const [clients, setClients] = useState(1);
    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        // district: false,
        month: false,
        year: false,
        project: false,
        clients: false,
    });
    const [errors, setErrors] = useState({});
    const yearInputRef = useRef(null);
    const [designationData, setDesignationData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && month && year && project;
    // Function to calculate days in a month
    // const getDaysInMonth = (monthId, year) => {
    //     const monthIndex = monthId - 1; // Convert to 0-based for Date object
    //     if (!monthId || !year) return 0;

    //     const monthsWith31Days = [1, 3, 5, 7, 8, 10, 12];
    //     const monthsWith30Days = [4, 6, 9, 11];

    //     if (monthsWith31Days.includes(monthId)) {
    //         return 31;
    //     } else if (monthsWith30Days.includes(monthId)) {
    //         return 30;
    //     } else if (monthId === 2) {
    //         const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    //         return isLeapYear ? 29 : 28;
    //     }
    //     return 0;
    // };

    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);

    // Fetch months
    // useEffect(() => {
    //     const fetchMonths = async () => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
    //             setMonthOptions(
    //                 response.data
    //                     .map(item => ({
    //                         value: item.monthId,
    //                         label: item.monthName,
    //                     }))
    //                     .sort((a, b) => a.value - b.value)
    //             );
    //         } catch (error) {
    //             console.error('Error fetching months:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
    //         }
    //     };
    //     fetchMonths();
    // }, []);
    // Fetch months
    // useEffect(() => {
    //     const fetchMonths = async () => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
    //             const now = new Date();
    //             const currentYear = now.getFullYear();
    //             const currentMonth = now.getMonth() + 1; // Jan=1
    //             const currentDate = now.getDate();
    //             const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate(); // ✅ last day of current month

    //             const months = response.data
    //                 .map(item => {
    //                     let daysInMonth;

    //                     // If it's the current month of the current year
    //                     if (year === currentYear && item.monthId === currentMonth) {
    //                         daysInMonth = currentDate;
    //                     } else {
    //                         daysInMonth = new Date(year, item.monthId, 0).getDate();
    //                     }

    //                     return {
    //                         value: item.monthId,
    //                         label: item.monthName,
    //                         days: daysInMonth,
    //                     };
    //                 })
    //                 .sort((a, b) => a.value - b.value);

    //             let filteredMonths = months;
    //             if (year) {
    //                 if (year === currentYear) {
    //                     filteredMonths = months.filter(m => {
    //                         if (m.value < currentMonth) return true; // past months always visible
    //                         if (m.value === currentMonth) {
    //                             // ✅ Show current month only if today is the last day
    //                             return currentDate === lastDayOfCurrentMonth;
    //                         }
    //                         return false;
    //                     });
    //                 } else if (year > currentYear) {
    //                     filteredMonths = []; // future year → no months
    //                 } else {
    //                     filteredMonths = months; // past year → all months
    //                 }
    //             }
    //             setMonthOptions(filteredMonths);
    //         } catch (error) {
    //             console.error('Error fetching months:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
    //         }
    //     };
    //     fetchMonths();
    // }, [year]);

    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);

                    const filterData = [
                        { value: 0, label: "All Districts" },
                        ...data.filter(item => item.districtId === 39).map(item => ({
                            value: item.districtId,
                            label: item.districtName
                        }))
                    ];

                    setDistrictOptions(filterData);
                    // ✅ Set district to the default 'All Districts' option when state loads
                    // setDistrict(0);

                } catch (err) {
                    console.error('Error fetching districts:', err);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null); // Clear district if state is cleared
        }
    }, [state]);
    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchClients = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
                    const data = await getClients(state);
                    setClientResponse(data.map(client => ({
                        value: client.id,
                        label: client.clientName,
                    }))
                    );
                } catch (error) {
                    console.error('Error fetching states:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
                }
            };
            fetchClients();
        }
        else {
            setClients(null);
        }
    }, [state]);


    useEffect(() => {
        if (clients) {
            const fetchProjects = async () => {
                try {
                    const data = await getProject(clients);
                    setProjectResponse(data.map(pro => ({
                        value: pro.id,
                        label: pro.projectCode,
                    })));
                } catch (error) {
                    console.error('Error fetching projects:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
                }
            };

            fetchProjects();
        } else {
            setProjectResponse([]); // Reset projects if no client is selected
        }
    }, [clients]);
    // useEffect(() => {
    //     if (!effectRan.current) {
    //         fetchProjects();
    //     }
    //     return () => {
    //         effectRan.current = true;
    //     }

    // }, [state, district, year]);  // Fetch projects when state, district, or year changes


    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, month, year, project]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        let value = selectedOption ? selectedOption.value : null;
        // Special handling for "All Districts"
        // Special handling for "All Districts"
        if (field === "district" && value === 0) {
            value = 0; // 0 = All districts (numeric, compatible with ID-based logic)
        }
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setProject(null); // ✅ Clear project when state changes
                break;
            case 'clients':
                setClients(value);
                setProject(null);
                break;
            case 'district':
                setDistrict(value);
                // setMonth(null);
                break;
            case 'month':
                setMonth(value);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        setYear(date ? date.getFullYear() : null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        // if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const data = await getFinalAttendanceReport({
                stateId: state,
                districtId: district === 0 ? null : district,
                month,
                year,
                projectId: project,
            });



            // Directly set the array
            const initializedData = data.map(item => ({
                ...item,
                casualLeave: item.casualLeave || 0,
                absentDays: item.absentDays || 0,
            }));

            setAttendanceData(initializedData);
            console.log("Fetched Attendance Data:", initializedData);

        } catch (error) {
            console.error("Error fetching report data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch report data",
            }));
            alert("Failed to fetch report data. Please try again.");
        }
    };





    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);


    // const generateExcel = async () => {
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet("Monthly Attendance");

    //     // --- Setup Title and Info ---
    //     // Determine merge range based on district selection
    //     const titleMergeRange = district ? "A1:V1" : "A1:N1";
    //     worksheet.mergeCells(titleMergeRange);
    //     const titleCell = worksheet.getCell("A1");
    //     titleCell.value = "Final Attendance Report";
    //     titleCell.font = { size: 16, bold: true };
    //     titleCell.alignment = { vertical: "middle", horizontal: "center" };

    //     const now = new Date();
    //     const dd = String(now.getDate()).padStart(2, "0");
    //     const mm = String(now.getMonth() + 1).padStart(2, "0");
    //     const yyyy = now.getFullYear();
    //     const reportDateTime = `${dd}-${mm}-${yyyy}`;

    //     worksheet.mergeCells("K3");
    //     worksheet.getCell("K3").value = "Report Date";
    //     worksheet.getCell("K3").font = { bold: true };
    //     worksheet.getCell("K3").alignment = { horizontal: "right" };

    //     worksheet.mergeCells("L3");
    //     worksheet.getCell("L3").value = reportDateTime;
    //     worksheet.getCell("L3").alignment = { horizontal: "center" };

    //     worksheet.addRow([]);

    //     const stateLabel = stateOptions.find(opt => opt.value === state)?.label || "N/A";
    //     const districtLabel = districtOptions.find(opt => opt.value === district)?.label || "N/A";
    //     const monthLabel = monthOptions.find(opt => opt.value === month)?.label || "N/A";
    //     const projectLabel = projectResponse.find(opt => opt.value === project)?.label || "N/A";
    //     const clientLabel = clientResponse.find(opt => opt.value === clients)?.label || "N/A";
    //     const monthNumber = Number(month) || now.getMonth() + 1;
    //     const yearNumber = Number(year) || now.getFullYear();
    //     const daysInMonth = new Date(yearNumber, monthNumber, 0).getDate();

    //     // State, Client, Project info
    //     worksheet.mergeCells("K5:L5");
    //     worksheet.getCell("K5").value = "State: " + stateLabel;
    //     worksheet.mergeCells("K6:L6");
    //     worksheet.getCell("K6").value = "District: " + districtLabel;
    //     worksheet.mergeCells("K7:L7");
    //     worksheet.getCell("K7").value = "Client: " + clientLabel;
    //     worksheet.mergeCells("K8:L8");
    //     worksheet.getCell("K8").value = "Project: " + projectLabel;

    //     // --- Month, Year, Days (Dynamic Rich Text with Bold Black Values) ---
    //     worksheet.mergeCells("A8:J8");
    //     worksheet.getCell("A8").value = {
    //         richText: [
    //             { text: "Month: ", font: { bold: false, color: { argb: "000000" } } },
    //             { text: `${monthLabel}  `, font: { bold: true, color: { argb: "000000" } } }, // black bold
    //             { text: "Year: ", font: { bold: false, color: { argb: "000000" } } },
    //             { text: `${year || "N/A"}  `, font: { bold: true, color: { argb: "000000" } } }, // black bold
    //             { text: "| No. of Days in Month: ", font: { bold: false, color: { argb: "000000" } } },
    //             { text: `${daysInMonth}`, font: { bold: true, color: { argb: "000000" } } }, // black bold
    //         ],
    //     };
    //     worksheet.getCell("A8").alignment = { horizontal: "left", vertical: "middle" };

    //     // --- Header Rows ---
    //     let headerRow1 = ["S.No", "District Name"];
    //     let headerRow2 = ["", ""];

    //     let metrics = ["No of Days Worked", "Total Days in Month", "No of Days Absent", "No of Employee"];
    //     let categories = district ? ["PM", "DC", "APM", "Help Desk", "Call Center"] : ["ITM", "CRO", "DEO"];

    //     // Build header rows
    //     metrics.forEach(metric => {
    //         headerRow1.push(metric);
    //         for (let i = 1; i < categories.length; i++) headerRow1.push(""); // empty cells for merge
    //         categories.forEach(cat => headerRow2.push(cat));
    //     });

    //     worksheet.addRow(headerRow1); // Row 9
    //     worksheet.addRow(headerRow2); // Row 10
    //     const thinBorder = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };

    //     // --- Row 9 Styling (Metrics) ---
    //     const row9 = worksheet.getRow(9);
    //     const metricColors = ["FFFFD1DA", "FFC1DFFF", "FFC3FCE9", "FFF4FFCE"]; // Pink, Green, Yellow, Orange

    //     // Merge Row 9 metric cells dynamically
    //     let colIndex = 3;
    //     metrics.forEach((metric, i) => {
    //         const startCol = colIndex;
    //         const endCol = startCol + categories.length - 1;

    //         // Merge metric cells
    //         worksheet.mergeCells(9, startCol, 9, endCol);

    //         // Apply background color, bold, center, border
    //         for (let col = startCol; col <= endCol; col++) {
    //             const cell = row9.getCell(col);
    //             cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: metricColors[i] } };
    //             cell.font = { bold: true };
    //             cell.alignment = { horizontal: "center", vertical: "middle" };
    //             cell.border = thinBorder;
    //         }

    //         colIndex += categories.length;
    //     });

    //     // S.No & District styling for Row 9
    //     [1, 2].forEach(c => {
    //         const cell = row9.getCell(c);
    //         cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } }; // Dark Blue
    //         cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    //         cell.alignment = { horizontal: "center", vertical: "middle" };
    //         cell.border = thinBorder;
    //     });

    //     // --- Row 10 Styling (Header Categories) ---
    //     const row10 = worksheet.getRow(10);
    //     //const thinBorder = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };

    //     // Colors: Pink, Green, Yellow, Orange
    //     const colors = ["FFFFD1DA", "FFC1DFFF", "FFC3FCE9", "FFF4FFCE"];

    //     metrics.forEach((_, i) => {
    //         const startCol = 3 + i * categories.length;
    //         const endCol = startCol + categories.length - 1;
    //         for (let col = startCol; col <= endCol; col++) {
    //             const cell = row10.getCell(col);
    //             cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors[i] } };
    //             cell.font = { bold: true };
    //             cell.alignment = { horizontal: "center", vertical: "middle" };
    //             cell.border = thinBorder;
    //         }
    //     });

    //     // S.No & District styling
    //     [1, 2].forEach(c => {
    //         const cell = row10.getCell(c);
    //         cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } }; // Dark Blue
    //         cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    //         cell.alignment = { horizontal: "center", vertical: "middle" };
    //         cell.border = thinBorder;
    //     });
    //     // --- Increase Column Widths ---
    //     worksheet.columns = [
    //         { width: 6 },   // S.No
    //         { width: 25 },  // District Name
    //         // Categories dynamically
    //         ...Array(categories.length * metrics.length).fill({ width: 12 }),
    //     ];
    //     // --- Body Rows ---
    //     const v = val => (val !== null && val !== undefined && val !== "") ? val : "-";

    //     let bodyFields = district
    //         ? ["pmWorked", "pmdcWorked", "apmWorked", ("hdoWorked", "hdopWorked"), "ccoWorked", "pmTotal", "pmdcTotal", "apmTotal", ("hdoTotal", "hdopTotal"), "ccoTotal", "pmAbsent", "pmdcAbsent", "apmAbsent", ("hdoAbsent", "hdopAbsent"), "ccoAbsent", "totalPmEmployees", "totalPmdcEmployees", "totalApmEmployees", ("totalHdoEmployees", "totalHdopEmployees"), "totalCcoEmployees"]
    //         : ["itmWorked", "croWorked", "deoWorked", "itmTotal", "croTotal", "deoTotal", "itmAbsent", "croAbsent", "deoAbsent", "totalItmEmployees", "totalCroEmployees", "totalDeoEmployees"];

    //     attendanceData.forEach((row, index) => {
    //         let rowData = [index + 1, row.districtName];
    //         bodyFields.forEach(field => rowData.push(v(row[field])));
    //         worksheet.addRow(rowData);
    //     });

    //     // --- Total Row ---
    //     const calcTotal = field => attendanceData.reduce((sum, r) => sum + (Number(r[field]) || 0), 0);
    //     const calcHDO = (f1, f2) => attendanceData.reduce((sum, r) => sum + (Number(r[f1]) || 0) + (Number(r[f2]) || 0), 0);

    //     let totalRowData = ["Total", ""];
    //     if (district) {
    //         totalRowData.push(
    //             calcTotal("pmWorked"), calcTotal("pmdcWorked"), calcTotal("apmWorked"), calcHDO("hdoWorked", "hdopWorked"), calcTotal("ccoWorked"),
    //             calcTotal("pmTotal"), calcTotal("pmdcTotal"), calcTotal("apmTotal"), calcHDO("hdoTotal", "hdopTotal"), calcTotal("ccoTotal"),
    //             calcTotal("pmAbsent"), calcTotal("pmdcAbsent"), calcTotal("apmAbsent"), calcHDO("hdoAbsent", "hdopAbsent"), calcTotal("ccoAbsent"),
    //             calcTotal("totalPmEmployees"), calcTotal("totalPmdcEmployees"), calcTotal("totalApmEmployees"), calcHDO("totalHdoEmployees", "totalHdopEmployees"), calcTotal("totalCcoEmployees")
    //         );
    //     } else {
    //         bodyFields.forEach(f => totalRowData.push(calcTotal(f)));
    //     }

    //     const totalRow = worksheet.addRow(totalRowData);
    //     totalRow.font = { bold: true };
    //     totalRow.eachCell(cell => {
    //         cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE699" } };
    //         cell.border = thinBorder;
    //     });

    //     // --- Download File ---
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const blob = new Blob([buffer], { type: "application/octet-stream" });
    //     const link = document.createElement("a");
    //     link.href = URL.createObjectURL(blob);
    //     link.download = `Final_Monthly_Attendance_${month}_${year}.xlsx`;
    //     link.click();
    // };


// --- DYNAMIC EXCEL ENGINE ---
    const generateExcel = async () => {
        if (!attendanceData || attendanceData.length === 0) {
            alert("No data available to generate export file.");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Attendance Summary");

        const selectedProjectObj = projectResponse.find(opt => opt.value === project);
        const projectLabel = selectedProjectObj ? selectedProjectObj.label : "N/A";
        const isCMRMode = projectLabel.toUpperCase() === "CMR" || project === 2 || project === "2";

        // Calculate columns count dynamically to wrap sheet banners perfectly
        let metrics = ["No of Days Worked", "Total Days in Month", "No of Days Absent", "No of Employee"];
        let categories = district 
            ? ["PM", "DC", "APM", isCMRMode ? "Help Desk (HDOP)" : "Help Desk (HDO)", "Call Center"]
            : ["ITM", isCMRMode ? "HDO" : "CRO", "DEO"];

        const totalColumns = 2 + (metrics.length * categories.length);
        
        const getColumnLetter = (colNum) => {
            let letter = "";
            while (colNum > 0) {
                let rem = (colNum - 1) % 26;
                letter = String.fromCharCode(65 + rem) + letter;
                colNum = Math.floor((colNum - rem) / 26);
            }
            return letter;
        };
        const lastColLetter = getColumnLetter(totalColumns);

        // --- Document Title Banner ---
        worksheet.mergeCells(`A1:${lastColLetter}1`);
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "Final Attendance Report Summary";
        titleCell.font = { size: 16, bold: true, color: { argb: "FFFFFF" } };
        titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "1F4E78" } }; // Deep Royal Blue
        titleCell.alignment = { vertical: "middle", horizontal: "center" };
        worksheet.getRow(1).height = 40;

        const now = new Date();
        const reportDateTime = `${String(now.getDate()).padStart(2, "0")}-${String(now.getMonth() + 1).padStart(2, "0")}-${now.getFullYear()} ${format(now, 'HH:mm')}`;
        const daysInMonth = new Date(Number(year) || now.getFullYear(), Number(month) || (now.getMonth() + 1), 0).getDate();

        const stateLabel = stateOptions.find(opt => opt.value === state)?.label || "N/A";
        const districtLabel = districtOptions.find(opt => opt.value === district)?.label || "N/A";
        const monthLabel = monthOptions.find(opt => opt.value === month)?.label || "N/A";
        const clientLabel = clientResponse.find(opt => opt.value === clients)?.label || "N/A";

        worksheet.mergeCells("A3:E3");
        worksheet.getCell("A3").value = `State: ${stateLabel} | District: ${districtLabel} | Client: ${clientLabel}`;
        worksheet.getCell("A3").font = { size: 11, bold: true };

        worksheet.mergeCells("A4:F4");
        worksheet.getCell("A4").value = `Project: ${projectLabel} | Month-Year: ${monthLabel} ${year || ""} | Days in Month: ${daysInMonth}`;
        worksheet.getCell("A4").font = { size: 11, bold: true };

        // RIGHT ALIGNED EXPORT DATE BLOCK
        const exportStartLetter = getColumnLetter(totalColumns - 3);
        worksheet.mergeCells(`${exportStartLetter}4:${lastColLetter}4`);
        const rightExportCell = worksheet.getCell(`${exportStartLetter}4`);
        rightExportCell.value = `Export Date: ${reportDateTime}`;
        rightExportCell.font = { size: 11, bold: true, color: { argb: "595959" } };
        rightExportCell.alignment = { horizontal: "right", vertical: "middle" };

        worksheet.addRow([]); // Spacer row

        let headerRow1 = ["S.No", "District Name"];
        let headerRow2 = ["", ""];

        metrics.forEach(metric => {
            headerRow1.push(metric);
            for (let i = 1; i < categories.length; i++) headerRow1.push("");
            categories.forEach(cat => headerRow2.push(cat));
        });

        worksheet.addRow(headerRow1); // Row 6
        worksheet.addRow(headerRow2); // Row 7

        const thinBorder = {
            top: { style: "thin", color: { argb: "BFBFBF" } }, left: { style: "thin", color: { argb: "BFBFBF" } },
            bottom: { style: "thin", color: { argb: "BFBFBF" } }, right: { style: "thin", color: { argb: "BFBFBF" } }
        };

        const headerFills = ["FFFFD1DA", "FFC1DFFF", "FFC3FCE9", "FFF4FFCE"]; // Pink, Blue, Mint, Yellow/Green
        const baseHeaderColor = "4472C4"; 

        const row6 = worksheet.getRow(6);
        row6.height = 26;
        let colIndex = 3;

        metrics.forEach((metric, i) => {
            const startCol = colIndex;
            const endCol = startCol + categories.length - 1;
            worksheet.mergeCells(6, startCol, 6, endCol);
            for (let col = startCol; col <= endCol; col++) {
                const cell = row6.getCell(col);
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerFills[i] } };
                cell.font = { bold: true, size: 11, color: { argb: "000000" } };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = thinBorder;
            }
            colIndex += categories.length;
        });

        for (let c = 1; c <= 2; c++) {
            worksheet.mergeCells(6, c, 7, c);
            const cell = row6.getCell(c);
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } };
            cell.font = { bold: true, color: { argb: "FFFFFF" } };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.border = thinBorder;
        }

        const row7 = worksheet.getRow(7);
        row7.height = 22;
        metrics.forEach((_, i) => {
            const startCol = 3 + i * categories.length;
            const endCol = startCol + categories.length - 1;
            for (let col = startCol; col <= endCol; col++) {
                const cell = row7.getCell(col);
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: headerFills[i] } };
                cell.font = { bold: true, size: 10 };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = thinBorder;
            }
        });

        // Safe variable parameter identifiers matching table cells assignments
        let bodyFields = district
            ? [
                "pmWorked", "pmdcWorked", "apmWorked", isCMRMode ? "hdopWorked" : "hdoWorked", "ccoWorked",
                "pmTotal", "pmdcTotal", "apmTotal", isCMRMode ? "hdopTotal" : "hdoTotal", "ccoTotal",
                "pmAbsent", "pmdcAbsent", "apmAbsent", isCMRMode ? "hdopAbsent" : "hdoAbsent", "ccoAbsent",
                "totalPmEmployees", "totalPmdcEmployees", "totalApmEmployees", isCMRMode ? "totalHdopEmployees" : "totalHdoEmployees", "totalCcoEmployees"
              ]
            : [
                "itmWorked", isCMRMode ? "hdopWorked" : "croWorked", "deoWorked",
                "itmTotal", isCMRMode ? "hdopTotal" : "croTotal", "deoTotal",
                "itmAbsent", isCMRMode ? "hdopAbsent" : "croAbsent", "deoAbsent",
                "totalItmEmployees", isCMRMode ? "totalHdopEmployees" : "totalCroEmployees", "totalDeoEmployees"
              ];

        attendanceData.forEach((row, index) => {
            let rowData = [index + 1, row.districtName || "-"];
            bodyFields.forEach(field => {
                const val = row[field];
                rowData.push(val !== undefined && val !== null && val !== "" ? val : 0);
            });

            const addedRow = worksheet.addRow(rowData);
            addedRow.height = 20;
            addedRow.eachCell((cell, colNum) => {
                cell.border = thinBorder;
                cell.alignment = { vertical: "middle", horizontal: colNum <= 2 ? "left" : "center" };
                cell.font = { size: 10 };
            });
        });

        // Totals Summaries calculations logic block
        const calcTotal = field => attendanceData.reduce((sum, r) => sum + (Number(r[field]) || 0), 0);
        const calcHDO = (f1, f2) => attendanceData.reduce((sum, r) => sum + (Number(r[f1]) || 0) + (Number(r[f2]) || 0), 0);

        let totalRowData = ["Total", ""];
        if (district) {
            totalRowData.push(
                calcTotal("pmWorked"), calcTotal("pmdcWorked"), calcTotal("apmWorked"), calcHDO("hdoWorked", "hdopWorked"), calcTotal("ccoWorked"),
                calcTotal("pmTotal"), calcTotal("pmdcTotal"), calcTotal("apmTotal"), calcHDO("hdoTotal", "hdopTotal"), calcTotal("ccoTotal"),
                calcTotal("pmAbsent"), calcTotal("pmdcAbsent"), calcTotal("apmAbsent"), calcHDO("hdoAbsent", "hdopAbsent"), calcTotal("ccoAbsent"),
                calcTotal("totalPmEmployees"), calcTotal("totalPmdcEmployees"), calcTotal("totalApmEmployees"), calcHDO("totalHdoEmployees", "totalHdopEmployees"), calcTotal("totalCcoEmployees")
            );
        } else {
            bodyFields.forEach(f => {
                if (f === "hdopWorked" || f === "croWorked") {
                    totalRowData.push(calcHDO("hdopWorked", "croWorked"));
                } else if (f === "hdopTotal" || f === "croTotal") {
                    totalRowData.push(calcHDO("hdopTotal", "croTotal"));
                } else if (f === "hdopAbsent" || f === "croAbsent") {
                    totalRowData.push(calcHDO("hdopAbsent", "croAbsent"));
                } else if (f === "totalHdopEmployees" || f === "totalCroEmployees") {
                    totalRowData.push(calcHDO("totalHdopEmployees", "totalCroEmployees"));
                } else {
                    totalRowData.push(calcTotal(f));
                }
            });
        }

        const totalRow = worksheet.addRow(totalRowData);
        totalRow.height = 24;
        totalRow.font = { bold: true, size: 11 };
        worksheet.mergeCells(`A${totalRow.number}:B${totalRow.number}`);
        
        totalRow.eachCell(cell => {
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE699" } }; // Accent Gold Total Row
            cell.border = thinBorder;
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });
        worksheet.getCell(`A${totalRow.number}`).alignment = { vertical: "middle", horizontal: "left" };

        worksheet.columns.forEach((col, index) => {
            if (index === 0) col.width = 6;
            else if (index === 1) col.width = 24;
            else col.width = 11;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Final_Monthly_Attendance_Report_${monthLabel}_${year}.xlsx`;
        link.click();
    };



    return (
        <div className="fina-report-container">
            <div className="fina-report-box">
                <h2 className="fina-report-heading">Final Attendance Report</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}
                >
                    <div className="fina-report-maincontainer">
                        <div className="fina-report-container-part">
                            <div className={`fina-report-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="fina-report-container-part">
                            <div className="fina-report-container-part">
                                <div className={`fina-report-floating-label-container ${isFocused.district || district !== null ? 'float-label' : ''}`}>
                                    <Select
                                        // ... (other Select props)
                                        name="district"
                                        options={districtOptions}
                                        // value comparison remains correct
                                        value={districtOptions.find(opt => opt.value === district) || null}
                                        onChange={option => handleInputChange(option, 'district')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>Working District</label>
                                    {errors.district && <div className="error-message">{errors.district}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="fina-report-maincontainer">
                        <div className="fina-report-container-part">
                            <div className={`fina-report-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="fina-report-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>Year</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="fina-report-container-part">
                            <div className={`fina-report-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Month</label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="fina-report-maincontainer">
                        <div className="epf-esic-updation-container-part">
                            <div className={`epf-esic-updation-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={clientResponse}
                                    value={clientResponse.find(opt => opt.value === clients) || null}
                                    onChange={option => handleInputChange(option, 'clients')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Client</label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>

                        </div>
                        <div className="fina-report-container-part">
                            <div className={`fina-report-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>
                                    <span className="required">*</span>Project
                                </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>
                        </div>

                    </div>
                    <div className="fina-report-btn-div">
                        <button type="submit" className="fina-report-btn"
                            disabled={!isFetchDataEnabled}


                        >
                            Generate Report
                        </button>
                    </div>
                </form>
            </div>
            <div className="fina-report-btn-div">
                <button
                    type="button"
                    className="fina-report-btn"
                    onClick={generateExcel}
                    disabled={attendanceData.length === 0}  // ✅ disabled if no data
                >
                    Download Excel
                </button>
                {/* <button
                    type="button"
                    className="fina-report-btn"
                    onClick={generatePDF}
                    disabled={attendanceData.length === 0}  // ✅ disabled if no data
                >
                    Download PDF
                </button> */}
            </div>

            <div className="final-table">
                {district ? (
                    <div className='final-mid-table'>

                        <table className="final-report">

                            <thead>
                                <tr>
                                    <th rowSpan={2}>S.No</th>
                                    <th rowSpan={2}>District Name</th>
                                    <th colSpan={5}>No of Days Worked</th>
                                    <th colSpan={5}>Total Days in Month</th>
                                    <th colSpan={5}>No of Days Absent</th>
                                    <th colSpan={5}>No of Employee</th>
                                </tr>
                                <tr>

                                    <th className='noof-working-days-color-header'>PM</th>
                                    <th className='noof-working-days-color-header'>DC</th>
                                    <th className='noof-working-days-color-header'>APM</th>
                                    <th className='noof-working-days-color-header'>Help Desk</th>
                                    <th className='noof-working-days-color-header'>Call Center</th>

                                    <th className='total-days-inmon-color-header'>PM</th>
                                    <th className='total-days-inmon-color-header'>DC</th>
                                    <th className='total-days-inmon-color-header'>APM</th>
                                    <th className='total-days-inmon-color-header'>Help Desk</th>
                                    <th className='total-days-inmon-color-header'>Call Center</th>

                                    <th className='noof-days-absent-color-header'>PM</th>
                                    <th className='noof-days-absent-color-header'>DC</th>
                                    <th className='noof-days-absent-color-header'>APM</th>
                                    <th className='noof-days-absent-color-header'>Help Desk</th>
                                    <th className='noof-days-absent-color-header'>Call Center</th>

                                    <th className='noof-emp-color-header'>PM</th>
                                    <th className='noof-emp-color-header'>DC</th>
                                    <th className='noof-emp-color-header'>APM</th>
                                    <th className='noof-emp-color-header'>Help Desk</th>
                                    <th className='noof-emp-color-header'>Call Center</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attendanceData.length > 0 ? (
                                    <>
                                        {/* Total Row */}
                                        <tr style={{ fontWeight: "bold", backgroundColor: "#whitesmoke" }}>
                                            <td colSpan={2}>Total</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmWorked || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmdcWorked || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.apmWorked || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + ((r.hdoWorked || 0) + (r.hdopWorked || 0)), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.ccoWorked || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmTotal || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmdcTotal || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.apmTotal || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + ((r.hdoTotal || 0) + (r.hdopTotal || 0)), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.ccoTotal || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmAbsent || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.pmdcAbsent || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.apmAbsent || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + ((r.hdoAbsent || 0) + (r.hdopAbsent || 0)), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.ccoAbsent || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalPmEmployees || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalPmdcEmployees || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalApmEmployees || 0), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + ((r.totalHdoEmployees || 0) + (r.totalHdopEmployees || 0)), 0)}</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalCcoEmployees || 0), 0)}</td>
                                        </tr>

                                        {attendanceData.map((row, index) => (
                                            <tr key={row.districtName + index}>
                                                <td>{index + 1}</td>
                                                <td>{row.districtName}</td>

                                                <td>{row.pmWorked || '-'}</td>
                                                <td>{row.pmdcWorked || '-'}</td>
                                                <td>{row.apmWorked || '-'}</td>
                                                <td>{row.hdoWorked || row.hdopWorked || '-'}</td>
                                                <td>{row.ccoWorked || '-'}</td>

                                                <td>{row.pmTotal || '-'}</td>
                                                <td>{row.pmdcTotal || '-'}</td>
                                                <td>{row.apmTotal || '-'}</td>
                                                <td>{row.hdoTotal || row.hdopTotal || '-'}</td>
                                                <td>{row.ccoTotal || '-'}</td>

                                                <td>{row.pmAbsent || '-'}</td>
                                                <td>{row.pmdcAbsent || '-'}</td>
                                                <td>{row.apmAbsent || '-'}</td>
                                                <td>{row.hdoAbsent || row.hdopAbsent || '-'}</td>
                                                <td>{row.ccoAbsent || '-'}</td>

                                                <td>{row.totalPmEmployees || '-'}</td>
                                                <td>{row.totalPmdcEmployees || '-'}</td>
                                                <td>{row.totalApmEmployees || '-'}</td>
                                                <td>{row.totalHdoEmployees || row.totalHdopEmployees || '-'}</td>
                                                <td>{row.totalCcoEmployees || '-'}</td>
                                            </tr>
                                        ))}
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="22" style={{ textAlign: "center", padding: "20px" }}>
                                            No attendance data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                ) : (
                    // Table when only stateId is provided
                    <div className='final-mid-table'>
                        <table className="final-report">

                            <thead>
                                <tr>
                                    <th rowSpan={2}>S.No</th>
                                    <th rowSpan={2}>District Name</th>
                                    <th colSpan={3}>No of Days Worked</th>
                                    <th colSpan={3}>Total Days in Month</th>
                                    <th colSpan={3}>No of Days Absent</th>
                                    <th colSpan={3}>No of Employee</th>
                                </tr>
                                <tr>

                                    <th className='noof-working-days-color-header' >ITM</th>
                                    {project === 2 || project === "CMR" ? (
                                        <th className='noof-working-days-color-header'>HDO</th>
                                    ) : (
                                        <th className='noof-working-days-color-header'>CRO</th>
                                    )}
                                    <th className='noof-working-days-color-header'>DEO</th>

                                    <th className='total-days-inmon-color-header'>ITM</th>
                                    {project === 2 || project === "CMR" ? (
                                        <th className='total-days-inmon-color-header'>HDO</th>
                                    ) : (
                                        <th className='total-days-inmon-color-header'>CRO</th>
                                    )}
                                    <th className='total-days-inmon-color-header'> DEO</th>

                                    <th className='noof-days-absent-color-header'>ITM</th>
                                    {project === 2 || project === "CMR" ? (
                                        <th className='noof-days-absent-color-header'>HDO</th>
                                    ) : (
                                        <th className='noof-days-absent-color-header'>CRO</th>
                                    )}
                                    <th className='noof-days-absent-color-header'>DEO</th>

                                    <th className='noof-emp-color-header'>ITM</th>
                                    {project === 2 || project === "CMR" ? (
                                        <th className='noof-emp-color-header'>HDO</th>
                                    ) : (
                                        <th className='noof-emp-color-header'>CRO</th>
                                    )}
                                    <th className='noof-emp-color-header'>DEO</th>

                                </tr>

                            </thead>
                            <tbody>
                                {attendanceData.length > 0 ? (
                                    <>
                                        {/* ✅ Total Row */}
                                        <tr style={{ fontWeight: "bold", backgroundColor: "#FFE699" }}>
                                            <td colSpan={2}>Total</td>
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.itmWorked || 0), 0)}</td>
                                            {project === 2 || project === "CMR" ? (
                                                <td>{attendanceData.reduce((sum, r) => sum + (r.hdopWorked || 0), 0)}</td>
                                            ) : (
                                                <td>{attendanceData.reduce((sum, r) => sum + (r.croWorked || 0), 0)}</td>
                                            )}
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.deoWorked || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.itmTotal || 0), 0)}</td>
                                            {project === 2 || project === "CMR" ? (
                                                <td>{attendanceData.reduce((sum, r) => sum + (r.hdopTotal || 0), 0)}</td>
                                            ) : (
                                                <td>{attendanceData.reduce((sum, r) => sum + (r.croTotal || 0), 0)}</td>
                                            )}
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.deoTotal || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.itmAbsent || 0), 0)}</td>
                                            {project === 2 || project === "CMR" ? (
                                                <td>{attendanceData.reduce((sum, r) => sum + (r.hdopAbsent || 0), 0)}</td>
                                            ) : (
                                                <td>{attendanceData.reduce((sum, r) => sum + (r.croAbsent || 0), 0)}</td>
                                            )}
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.deoAbsent || 0), 0)}</td>

                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalItmEmployees || 0), 0)}</td>
                                            {project === 2 || project === "CMR" ? (
                                                <td>{attendanceData.reduce((sum, r) => sum + (r.totalHdopEmployees || 0), 0)}</td>
                                            ) : (
                                                <td>{attendanceData.reduce((sum, r) => sum + (r.totalCroEmployees || 0), 0)}</td>
                                            )}
                                            <td>{attendanceData.reduce((sum, r) => sum + (r.totalDeoEmployees || 0), 0)}</td>

                                        </tr>
                                        {attendanceData.map((row, index) => (
                                            <tr key={row.districtName + index}>
                                                <td>{index + 1}</td>
                                                <td>{row.districtName}</td>

                                                <td>{row.itmWorked}</td>
                                                {project === 2 || project === "CMR" ? (
                                                    <td>{row.hdopWorked}</td>
                                                ) : (
                                                    <td>{row.croWorked }</td>
                                                )}
                                                <td>{row.deoWorked}</td>


                                                <td>{row.itmTotal}</td>
                                                {project === 2 || project === "CMR" ? (
                                                    <td>{row.hdopTotal}</td>
                                                ) : (
                                                    <td>{row.croTotal }</td>
                                                )}
                                                <td>{row.deoTotal}</td>




                                                <td>{row.itmAbsent}</td>
                                                {project === 2 || project === "CMR" ? (
                                                    <td>{row.hdopAbsent }</td>
                                                ) : (
                                                    <td>{row.croAbsent }</td>
                                                )}
                                                <td>{row.deoAbsent}</td>



                                                <td>{row.totalItmEmployees}</td>
                                                {project === 2 || project === "CMR" ? (
                                                    <td>{row.totalHdopEmployees }</td>
                                                ) : (
                                                    <td>{row.totalCroEmployees }</td>
                                                )}
                                                <td>{row.totalDeoEmployees}</td>

                                            </tr>
                                        ))}


                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="14" style={{ textAlign: "center", padding: "20px" }}>
                                            No attendance data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                )}
            </div>



        </div>
    );
};

export default FinalMonthlyReport;